import React from "react";
import { MessageCircle, Instagram, MapPin, Mail } from "lucide-react";
import { WHATSAPP_LINK, INSTAGRAM_URL, WHATSAPP_NUMBER } from "../lib/api";

const Contacto = () => {
  return (
    <div data-testid="contacto-page" className="pt-12 pb-24 min-h-screen bg-cream">
      <div className="max-w-7xl mx-auto px-6 md:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-start">
          <div>
            <span className="text-xs uppercase tracking-[0.25em] font-bold text-yolk">─ Contacto ─</span>
            <h1 className="mt-3 font-heading text-5xl md:text-6xl font-extrabold tracking-tight text-brand-ink leading-tight">
              Conversemos.<br /><span className="font-accent italic text-mint-deep">Estamos cerca</span>.
            </h1>
            <p className="mt-5 text-gray-700 leading-relaxed max-w-md">
              ¿Tienes una idea, un proyecto o solo una duda? Escríbenos por el canal que prefieras.
            </p>

            <a href={WHATSAPP_LINK("Hola, quiero cotizar mi proyecto personalizado")} target="_blank" rel="noreferrer" data-testid="contacto-wa-cta" className="btn-chunky inline-flex items-center gap-2 bg-yolk text-black px-6 py-4 mt-8 text-sm">
              <MessageCircle className="h-5 w-5" /> COTIZA TU PROYECTO PERSONALIZADO
            </a>

            <div className="mt-10">
              <Row icon={MessageCircle} label="WhatsApp" value={WHATSAPP_NUMBER} href={WHATSAPP_LINK()} testid="contacto-whatsapp" />
              <Row icon={Instagram} label="Instagram" value="@a.l.a_grafica_spa_copiapo" href={INSTAGRAM_URL} testid="contacto-instagram" />
              <Row icon={MapPin} label="Ubicación" value="Copiapó, Chile" testid="contacto-ubicacion" />
              <Row icon={Mail} label="Atención" value="Lun a Vie · 9:00 - 19:00" testid="contacto-horario" />
            </div>
          </div>

          <div className="relative">
            <div className="absolute -inset-4 bg-mint border-2 border-black" />
            <div className="relative aspect-[4/5] overflow-hidden border-2 border-black">
              <img
                src="https://images.pexels.com/photos/12598057/pexels-photo-12598057.jpeg?auto=compress&cs=tinysrgb&w=1200"
                alt="Figuras 3D ALA"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="absolute -bottom-6 -right-6 bg-yolk text-black p-6 max-w-[260px] border-2 border-black">
              <p className="font-accent italic text-xl leading-tight">"Donde tu idea se vuelve algo que puedes tocar."</p>
              <p className="mt-3 text-[10px] uppercase tracking-[0.25em] font-bold">— A.L.A Grafics</p>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

const Row = ({ icon: Icon, label, value, href, testid }) => {
  const Wrapper = href ? "a" : "div";
  const props = href ? { href, target: "_blank", rel: "noreferrer" } : {};
  return (
    <Wrapper {...props} data-testid={testid} className="group flex items-center gap-5 py-5 border-b-2 border-black transition">
      <div className="h-12 w-12 border-2 border-black flex items-center justify-center bg-white group-hover:bg-mint transition">
        <Icon className="h-5 w-5 text-brand-ink" />
      </div>
      <div className="flex-1">
        <p className="text-[10px] uppercase tracking-[0.25em] font-bold text-gray-400">{label}</p>
        <p className="text-base text-brand-ink font-heading font-bold">{value}</p>
      </div>
    </Wrapper>
  );
};

export default Contacto;
